import React from 'react';
import {List, ListItemButton, ListItemText} from "convertupleads-theme";
import {useNavigate} from "react-router-dom";

const SearchedElement = ({query}) => {
    const navigate = useNavigate()

    return (
        <>
            <List
                sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
                component="nav"
                aria-labelledby="nested-list-subheader"
            >
                {query.map((filteredlist)=>(
                    <ListItemButton onClick={()=> navigate(filteredlist?.link)}>
                        <ListItemText primary={filteredlist?.title} />
                    </ListItemButton>
                ) )}
            </List>
        </>
    );
};

export default SearchedElement;